import React from 'react';
import properyItemModel from '../models/properyItem';
import whatAreYourInterestsApi from '../api/whatAreYourInterestsApi';

class WhatAreYourInterestsService {
  loadGeneralData(params) {
    return whatAreYourInterestsApi
      .loadGeneralData(params)
      .then(res => {
        if (res.success) {
          res.data.items = properyItemModel.mappingObjects(res.data.items);
        } else {
          console.log('ERROR: WhatAreYourInterestsService/loadGeneralData:', res);
        }
        return res;
      })
      .catch(e => {
        console.log('ERROR: WhatAreYourInterestsService/loadGeneralData:', e);
        throw new Error('failed');
      });
  }

  loadSexualDataSignle(params) {
    return whatAreYourInterestsApi
      .loadSexualDataSignle(params)
      .then(res => {
        if (res.success) {
          res.data.items = properyItemModel.mappingObjects(res.data.items);
        } else {
          console.log('ERROR: WhatAreYourInterestsService/loadGeneralData:', res);
        }
        return res;
      })
      .catch(e => {
        console.log('ERROR: WhatAreYourInterestsService/loadGeneralData:', e);
        throw new Error('failed');
      });
  }

  loadSexualDataCouple(params) {
    return whatAreYourInterestsApi
      .loadSexualDataCouple(params)
      .then(res => {
        if (res.success) {
          res.data.items = properyItemModel.mappingObjects(res.data.items);
        } else {
          console.log('ERROR: WhatAreYourInterestsService/loadGeneralData:', res);
        }
        return res;
      })
      .catch(e => {
        console.log('ERROR: WhatAreYourInterestsService/loadGeneralData:', e);
        throw new Error('failed');
      });
  }

  loadFetishData(params) {
    return whatAreYourInterestsApi
      .loadFetishData(params)
      .then(res => {
        if (res.success) {
          res.data.items = properyItemModel.mappingObjects(res.data.items);
        } else {
          console.log('ERROR: WhatAreYourInterestsService/loadFetishData:', res);
        }
        return res;
      })
      .catch(e => {
        console.log('ERROR: WhatAreYourInterestsService/loadFetishData:', e);
        throw new Error('failed');
      });
  }
}

export default new WhatAreYourInterestsService();
